import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import jaCommon from './locales/ja/common.json';
import jaAuth from './locales/ja/auth.json';
import jaTransaction from './locales/ja/transaction.json';
import jaBudget from './locales/ja/budget.json';
import jaCategory from './locales/ja/category.json';
import jaSettlement from './locales/ja/settlement.json';
import jaSummary from './locales/ja/summary.json';
import jaCsv from './locales/ja/csv.json';
import jaCurrency from './locales/ja/currency.json';
import jaAccount from './locales/ja/account.json';

import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enTransaction from './locales/en/transaction.json';
import enBudget from './locales/en/budget.json';
import enCategory from './locales/en/category.json';
import enSettlement from './locales/en/settlement.json';
import enSummary from './locales/en/summary.json';
import enCsv from './locales/en/csv.json';
import enCurrency from './locales/en/currency.json';
import enAccount from './locales/en/account.json';

import thCommon from './locales/th/common.json';
import thAuth from './locales/th/auth.json';
import thTransaction from './locales/th/transaction.json';
import thBudget from './locales/th/budget.json';
import thCategory from './locales/th/category.json';
import thSettlement from './locales/th/settlement.json';
import thSummary from './locales/th/summary.json';
import thCsv from './locales/th/csv.json';
import thCurrency from './locales/th/currency.json';
import thAccount from './locales/th/account.json';

// Translation resources
const resources = {
  ja: {
    common: jaCommon,
    auth: jaAuth,
    transaction: jaTransaction,
    budget: jaBudget,
    category: jaCategory,
    settlement: jaSettlement,
    summary: jaSummary,
    csv: jaCsv,
    currency: jaCurrency,
    account: jaAccount,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    transaction: enTransaction,
    budget: enBudget,
    category: enCategory,
    settlement: enSettlement,
    summary: enSummary,
    csv: enCsv,
    currency: enCurrency,
    account: enAccount,
  },
  th: {
    common: thCommon,
    auth: thAuth,
    transaction: thTransaction,
    budget: thBudget,
    category: thCategory,
    settlement: thSettlement,
    summary: thSummary,
    csv: thCsv,
    currency: thCurrency,
    account: thAccount,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'ja',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false,
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    
    defaultNS: 'common',
    ns: ['common', 'auth', 'transaction', 'budget', 'category', 'settlement', 'summary', 'csv', 'currency', 'account'],
  });

export default i18n;